import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onClick", "onRef"];
import * as React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { alpha, styled } from '@mui/material/styles';
import { useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SearchButtonStyled = styled('button')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return [(_ref2 = {
    minHeight: 32,
    minWidth: 32,
    margin: 0,
    paddingLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref2, theme.breakpoints.only('xs'), {
    backgroundColor: 'transparent',
    padding: 0,
    justifyContent: 'center',
    '& > *:not(.MuiSvgIcon-root)': {
      display: 'none'
    }
  }), "position", 'relative'), "backgroundColor", alpha(theme.palette.grey[50], 0.6)), "fontFamily", theme.typography.fontFamily), "fontSize", theme.typography.pxToRem(14)), "color", (theme.vars || theme).palette.text.secondary), "border", "1px solid ".concat((theme.vars || theme).palette.grey[200])), "borderRadius", (theme.vars || theme).shape.borderRadius), "cursor", 'pointer'), "transitionProperty", 'all'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref2, "transitionDuration", '150ms'), "boxShadow", "hsl(200, 0%, 100%) 0 1px 0 inset, ".concat(alpha(theme.palette.grey[100], 0.4), " 0 -1px 0 inset, ").concat(alpha(theme.palette.grey[200], 0.5), " 0 1px 2px 0")), '&:hover', {
    background: alpha(theme.palette.grey[100], 0.5),
    borderColor: (theme.vars || theme).palette.grey[300],
    boxShadow: 'none'
  }), '&:focus-visible', {
    outline: "3px solid ".concat(alpha(theme.palette.primary[500], 0.5)),
    outlineOffset: '2px'
  })), theme.applyDarkStyles({
    backgroundColor: alpha(theme.palette.primaryDark[700], 0.4),
    borderColor: alpha(theme.palette.primaryDark[600], 0.4),
    boxShadow: "".concat(alpha(theme.palette.primaryDark[600], 0.1), " 0 1px 0 inset, ").concat((theme.vars || theme).palette.common.black, " 0 -1px 0 inset, ").concat((theme.vars || theme).palette.common.black, " 0 1px 2px 0"),
    '&:hover': {
      background: (theme.vars || theme).palette.primaryDark[700],
      borderColor: (theme.vars || theme).palette.primaryDark[600],
      boxShadow: 'none'
    }
  })];
});
var SearchLabel = styled('span')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginRight: 'auto',
    marginBottom: '1px',
    // optical alignment
    color: (theme.vars || theme).palette.text.tertiary,
    lineHeight: 1
  };
});
var Shortcut = styled('kbd')(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({
    all: 'unset',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    lineHeight: '19px',
    marginLeft: theme.spacing(0.5),
    border: "1px solid ".concat((theme.vars || theme).palette.grey[200]),
    backgroundColor: '#FFF',
    padding: theme.spacing(0, 0.5),
    borderRadius: 7
  }, theme.applyDarkStyles({
    borderColor: (theme.vars || theme).palette.primaryDark[600],
    backgroundColor: (theme.vars || theme).palette.primaryDark[800]
  }));
});
var subscribe = function subscribe() {
  return function () {};
};
var getSnapshot = function getSnapshot() {
  return window.navigator.platform.toUpperCase().includes('MAC') ? '⌘K' : 'Ctrl+K';
};
var getServerSnapshot = function getServerSnapshot() {
  return null;
};
function useShortcut() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
export default function SearchButton(_ref5) {
  var onClick = _ref5.onClick,
    onRef = _ref5.onRef,
    props = _objectWithoutPropertiesLoose(_ref5, _excluded);
  var t = useTranslate();
  var shortcut = useShortcut();
  return /*#__PURE__*/_jsxs(SearchButtonStyled, _extends({
    ref: onRef,
    onClick: onClick,
    disabled: !onClick,
    "aria-labelledby": "app-search-label"
  }, props, {
    children: [/*#__PURE__*/_jsx(SearchIcon, {
      color: "primary",
      sx: {
        fontSize: '1.125rem'
      }
    }), /*#__PURE__*/_jsx(SearchLabel, {
      id: "app-search-label",
      children: t('searchButton')
    }), shortcut && /*#__PURE__*/_jsx(Shortcut, {
      "aria-hidden": "true",
      children: shortcut
    })]
  }));
}